import { CodebookModel } from 'app/shared/model/shared.model';

export enum PhasedConstructionType {
  PHASED = 1,
  STAGED = 2,
}

export interface PhasedConstruction {
  phaseNumber: string;
  phaseValue: string;
}

export interface StageConstruction {
  stageNumber: string;
  stageValue: string;
  phases: PhasedConstruction[];
}

export interface PhasedConstructionModel {
  phasedConstructionType: CodebookModel[];
  phases?: PhasedConstruction[];
  stages?: StageConstruction[];
}

export const initialPhasedConstructionModel = {
  phasedConstructionType: [],
  phases: [],
  stages: [],
};
